import React from 'react';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@mui/material';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  ContentCopy as CopyIcon,
  Visibility as ViewIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';

function EdgeContextMenu({
  open,
  anchorEl,
  onClose,
  edge,
  onEdit,
  onDelete,
  onCopy,
}) {
  const handleEdit = () => {
    onEdit(edge);
    onClose();
  };

  const handleDelete = () => {
    onDelete(edge);
    onClose();
  };

  const handleCopy = () => {
    onCopy(edge);
    onClose();
  };

  return (
    <Menu
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <MenuItem onClick={handleEdit}>
        <ListItemIcon>
          <EditIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Edit Edge</ListItemText>
      </MenuItem>

      <MenuItem onClick={handleCopy}>
        <ListItemIcon>
          <CopyIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Copy Edge</ListItemText>
      </MenuItem>

      <MenuItem>
        <ListItemIcon>
          <ViewIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>View Properties</ListItemText>
      </MenuItem>

      <Divider />

      <MenuItem onClick={handleDelete} sx={{ color: 'error.main' }}>
        <ListItemIcon>
          <DeleteIcon fontSize="small" color="error" />
        </ListItemIcon>
        <ListItemText>Delete Edge</ListItemText>
      </MenuItem>
    </Menu>
  );
}

export default EdgeContextMenu;
